<template>
	<div>
		<div class="panel m-5">
			<PanelHeader :panel-header="school ? school.attributes.name : 'Neue Schule/Kindergarten'" />
			<div class="container pt-3 pb-3">
				<div class="columns">
					<ValidatedSelection
							:key="schoolType ? schoolType.id : 'schoolType'"
							class="column" label="Schulform/Kindergarten" attributeName="name"
							:options="schoolTypesArray" :selected-option="schoolType"
							:select="(item) => (schoolType = item)" :has-validation="false"/>
				</div>
				<div class="columns">
					<InputWithValidation :key="isMounted ? 'nameU' : 'name'" class="column" :name="name"
						:set-name="(val) => (name = val)" label="Name" message="Bitte gib einen Namen ein!" />
					<InputComponent :key="isMounted ? 'emailu' : 'email'" class="column" :name="email" type="email"
						:set-name="(val) => (email = val)" label="E-Mail" />
				</div>
				<div class="columns">
					<InputComponent :key="isMounted ? 'phone1u' : 'phone1'" class="column" :name="phone1"
						:set-name="(val) => (phone1 = val)" label="Telefon 1" />
					<InputComponent :key="isMounted ? 'info1u' : 'info1'" class="column" :name="info1"
						:set-name="(val) => (info1 = val)" label="Info 1" />
				</div>
				<div class="columns">
					<InputComponent :key="isMounted ? 'phone2u' : 'phone2'" class="column" :name="phone2"
						:set-name="(val) => (phone2 = val)" label="Telefon 2" />
					<InputComponent :key="isMounted ? 'info2u' : 'info2'" class="column" :name="info2"
						:set-name="(val) => (info2 = val)" label="Info 2" />
				</div>
				<div class="columns">
					<InputComponent :key="isMounted ? 'streetu' : 'street'" class="column" :name="street"
						:set-name="(val) => (street = val)" label="Straße" />
					<InputComponent :key="isMounted ? 'plzu' : 'plz'" class="column" :name="plz"
						:set-name="(val) => (plz = val)" label="PLZ" />
					<InputComponent :key="isMounted ? 'locationu' : 'location'" class="column" :name="location"
						:set-name="(val) => (location = val)" label="Ort" />
				</div>
			</div>
		</div>

		<div class="m-5 buttons" style="display: flex; justify-content: center">
			<SaveButton :is-loading="isLoading" :save-function="save" :disabled="$v.name.$invalid
				" />
			<CancelButton text="Abbrechen" back-route="/schools" :is-loading="false" />
		</div>
	</div>
</template>

<script>
import {
	querySchoolTypes
} from "../../lib/Query";
import Parse from "parse/dist/parse.min"
import InputComponent from "../helperComponents/InputComponent"
import CancelButton from "@/components/helperComponents/CancelButton";
import SaveButton from "@/components/helperComponents/SaveButton";
import InputWithValidation from "@/components/helperComponents/InputWithValidation";
import { minLength, required } from "vuelidate/lib/validators";
import { positiveFeedBack } from "@/lib/Toast";
import PanelHeader from "@/components/helperComponents/PanelHeader";
import ValidatedSelection from "@/components/helperComponents/ValidatedSelection";
export default {
	name: "NewSchool",
	components: { PanelHeader, InputWithValidation, SaveButton, CancelButton, InputComponent, ValidatedSelection },
	data() {
		return {
			isMounted: false,
			isLoading: false,
			name: undefined,
			location: undefined,
			phone1: undefined,
			phone2: undefined,
			info1: undefined,
			info2: undefined,
			email: undefined,
			street: undefined,
			plz: undefined,
			school: undefined,
			schoolTypesArray: [],
			schoolType: undefined
		}
	},
	validations: {
		name: {
			required,
			minLength: minLength(1),
		},
	},
	async mounted() {
		this.schoolTypesArray = await querySchoolTypes();
		if (!this.$route.params.data) return (this.isMounted = true);
		this.school = this.$route.params.data;
		const { name, street, plz, location, email, phone1, phone2, info1, info2, schoolType } = this.school.attributes
		this.name = name
		this.street = street
		this.plz = plz
		this.location = location
		this.email = email
		this.phone1 = phone1
		this.phone2 = phone2
		this.info1 = info1
		this.info2 = info2
		this.isMounted = true
		console.log(schoolType);
		this.schoolType = schoolType ? schoolType.toPointer() : undefined;
	},
	methods: {
		async save() {
			console.log(this.schoolType);
			const Location = Parse.Object.extend("Location")
			const location = this.school ? this.school : new Location()
			location.set("name", this.name)
			location.set("street", this.street)
			location.set("plz", this.plz)
			location.set("location", this.location)
			location.set("email", this.email)
			location.set("phone1", this.phone1)
			location.set("info1", this.info1)
			location.set("phone2", this.phone2)
			location.set("info2", this.info2)
			location.set("type", "school")
			location.set("schoolType", this.schoolType)
			await location.save()
			await this.$router.push({ path: "/schools" })
			await positiveFeedBack("Schule/Kindergarten erstellt")
		}
	}
}
</script>

<style scoped></style>
